import React from "react"
import {SelectItem, Select, SelectTitle} from "./select"
import {ValidationResult} from "../../util/validation/validation-result"

export interface SingleSelectItem {
  id: any
  component: React.ReactChild
}

export interface SingleSelectProps {
  items: SingleSelectItem[]
  selectedItemId?: any
  personalData?: boolean
  disabled?: boolean
  onChange?: (selectedItemId: any) => void
  readonly showValidity?: boolean
  readonly validationResult?: ValidationResult
}

export const SingleSelect: React.FC<SingleSelectProps> = ({items, selectedItemId, showValidity, validationResult, personalData = false, disabled = false, onChange}) => {
  const selectedItem = items.find(item => item.id === selectedItemId)!
  const selectItems: SelectItem[] = items.map(item => ({
    id: item.id,
    component: item.component,
    selected: item.id === selectedItemId
  }))

  function handleChange(selectedItem: SelectItem) {
    if (onChange) {
      onChange(selectedItem.id)
    }
  }

  return <Select items={selectItems}
                 title={<SelectTitle>{selectedItem?.component}</SelectTitle>}
                 disabled={disabled}
                 showValidity={showValidity}
                 validationResult={validationResult ?? {valid: true}}
                 personalData={personalData ? true : undefined}
                 onChange={handleChange}/>
}
